import {useEffect, useState} from 'react';

const LOG_PREFIX = '[useCarverConfig]';
const BASE = (process.env.REACT_APP_AWP_API_BASE || process.env.REACT_APP_AWP_API_URL || '')
    .replace(/\/$/, '');

const FALLBACK = {enabledEntityTypes: [], minScore: 1, maxScore: 10};

/** Shared across mounts — the admin's choice changes rarely and every KB page wants the same answer. */
let cached = null;
let inFlight = null;

function fetchConfig() {
    if (cached) return Promise.resolve(cached);
    if (!inFlight) {
        inFlight = fetch(`${BASE}/api/kb/carver/config`)
            .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`${r.status}`))))
            .then((data) => {
                cached = {...FALLBACK, ...data};
                return cached;
            })
            .finally(() => {
                inFlight = null;
            });
    }
    return inFlight;
}

/**
 * Which entity types an admin has enabled for CARVER, and the score range the server accepts.
 * Falls back to the documented 1–10 range if the endpoint is unreachable.
 */
export function useCarverConfig() {
    const [config, setConfig] = useState(cached ?? FALLBACK);
    const [loading, setLoading] = useState(!cached);

    useEffect(() => {
        if (cached) return undefined;
        let cancelled = false;
        fetchConfig()
            .then((data) => {
                if (!cancelled) {
                    setConfig(data);
                    setLoading(false);
                }
            })
            .catch((err) => {
                if (cancelled) return;
                console.error(`${LOG_PREFIX} Error:`, err);
                setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return {...config, loading};
}
